import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function ChipSelector({ items, onPress, }) {
    return (_jsx(Container, { children: items.map(({ label, option, isSelected }, index) => (_jsx(FilterChip, { isActive: isSelected, text: label, onPress: () => onPress(option) }, index))) }));
}
function FilterChip({ isActive, text, onPress, }) {
    return (_jsx(FilterChipBox, { elementName: "search_filter_chip", disableLogging: true, isActive: isActive, onPress: onPress, children: _jsx(ChipText, { isActive: isActive, children: text }) }));
}
const Container = styled.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;
const FilterChipBox = styled(SccPressable) `
  display: flex;
  flex-direction: row;
  background-color: ${color.white};
  border-radius: 12px;
  border-width: 1px;
  border-color: ${({ isActive }) => (isActive ? color.brandColor : color.gray20)};
  align-items: center;
  justify-content: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 16px;
  padding-left: 16px;
`;
const ChipText = styled.Text `
  font-size: 14px;
  font-family: ${font.pretendardMedium};
  color: ${({ isActive }) => (isActive ? color.brandColor : color.gray90)};
`;
